// Spinner.jsx
import React from 'react';

const Spinner = ({ size = 16, color = 'text-muted' }) => {
  return (
    <div
      className={`animate-spin rounded-full mx-auto border-2 border-t-2 border-b-2 ${color}`}
      style={{ width: size, height: size, borderTopColor: 'transparent' }}
    ></div>
  );
};

export default Spinner;
